module.exports = __webpack_public_path__ + "static/media/icon_capture.8ccb95f3.png";